import {ErrorHandlerProvider, useErrorHandler} from "~/components/ErrorHandling/context";
import React, {useState} from "react";
import {Container} from "@mui/material";
import {Forbidden} from "~/components/ErrorBlocks/Forbidden";
import {ServiceUnavailable} from "~/components/ErrorBlocks/ServiceUnavailable";
import {isForbiddenError, isServiceUnavailableError} from "~/apollo/errors";
import {AbsoluteContainer} from "~/apps/core/ui/AbsoluteContainer";


export type ForbiddenAndUnavailableServiceErrorHandlerProviderProps = {
    children?: any
    appBar?: any
}


export const ForbiddenAndUnavailableServiceErrorHandlerProvider = (props: ForbiddenAndUnavailableServiceErrorHandlerProviderProps) => {
    const {children, appBar} = props;
    const parentErrorHandler = useErrorHandler();
    const [hasAccess, setHasAccess] = useState(true);
    const [endpointAvailable, setEndpointAvailable] = useState(true);

    const handleError = (error: Error) => {
        if (isForbiddenError(error)) {
            setHasAccess(false);
        } else if (isServiceUnavailableError(error)) {
            setEndpointAvailable(false);
        } else {
            parentErrorHandler(error);
        }
    }

    return (
        <ErrorHandlerProvider value={handleError}>
            {hasAccess && endpointAvailable? children : (
                <>
                    {appBar}
                    <AbsoluteContainer>
                        {!hasAccess && <Forbidden/>}
                        {!endpointAvailable && <ServiceUnavailable/>}
                    </AbsoluteContainer>
                </>
            )}
        </ErrorHandlerProvider>
    );
}